<template>
  <div>
    <DetailIndex :amzExpenseCode="params.code" />
  </div>
</template>
<script>
import DetailIndex from './components/detail'
export default {
  components: { DetailIndex },
  name: 'opview-amzExpense',
  computed: {
    params() {
      return this.$route.params
    },
  },
}
</script>
